export default __webpack_public_path__ + "static/media/stacks-stx-logo.92f8b72a.svg";